import { api, authHeader } from "../configs/axiosConfigs";

const unwrapPayload = (res) => res?.data?.data ?? res?.data ?? null;

const parseApiResult = (res, fallbackMessage = "") => ({
  ok: res?.data?.isSuccess === true,
  message: res?.data?.message || fallbackMessage,
  data: unwrapPayload(res),
});

const parseApiError = (error, fallbackMessage = "خطا در ارتباط با سرور") => {
  const data = error?.response?.data;
  const message =
    (typeof data?.message === "string" && data.message) ||
    (typeof data === "string" && data) ||
    error?.message ||
    fallbackMessage;
  return {
    ok: false,
    message,
    data: data?.data ?? null,
  };
};

const ApplicantContractFeeSettingsApi = {
  getCurrent: async () => {
    try {
      const res = await api.request({
        url: "api/sln/applicant-contract-fee-settings/current",
        method: "GET",
        headers: authHeader(),
      });
      return parseApiResult(res);
    } catch (error) {
      return parseApiError(error, "خطا در دریافت تنظیمات هزینه قرارداد.");
    }
  },

  getHistory: async (take = 50) => {
    try {
      const res = await api.request({
        url: "api/sln/applicant-contract-fee-settings/history",
        method: "GET",
        params: { take },
        headers: authHeader(),
      });
      return parseApiResult(res);
    } catch (error) {
      return parseApiError(error, "خطا در دریافت تاریخچه تنظیمات.");
    }
  },

  update: async (payload) => {
    try {
      const res = await api.request({
        url: "api/sln/applicant-contract-fee-settings",
        method: "PUT",
        headers: authHeader(),
        data: payload,
      });
      return parseApiResult(res, "خطا در ذخیره تنظیمات.");
    } catch (error) {
      return parseApiError(error, "خطا در ذخیره تنظیمات.");
    }
  },
};

export default ApplicantContractFeeSettingsApi;
